import React, { useState } from "react";
import { Button, Form, Modal, ListGroup } from "react-bootstrap";
import { useCart } from "../context/CartContext";
import { formatPrice } from "../utils/formatPrice";
import { formatModifierSummary } from "../utils/modifierUtils";

const MobileCart = ({ onCheckout, checkoutDisabled = false, checkoutLabel }) => {
  const { cart, addItem, removeItem, clearCart, orderNote, setOrderNote, setItemNote } = useCart();
  const [showModal, setShowModal] = useState(false);

  // Calculate total price
  const totalPrice = cart.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );

  // Calculate total items
  const totalItems = cart.reduce((total, item) => total + item.quantity, 0);

  const handleCheckout = () => {
    setShowModal(false);
    onCheckout();
  };

  // Don't show button if cart is empty
  if (totalItems === 0) {
    return null;
  }

  return (
    <>
      <div className="guest-cart-trigger">
        <Button
          variant="primary"
          className="guest-cart-trigger-button"
          onClick={() => setShowModal(true)}
        >
          <span className="guest-cart-trigger-copy">
            <span className="guest-cart-trigger-label">Sepet</span>
            <span className="guest-cart-trigger-count" aria-label={`${totalItems} ürün`}>
              {totalItems}
            </span>
          </span>
          <span className="guest-cart-trigger-total">{formatPrice(totalPrice)}</span>
        </Button>
      </div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
        fullscreen="md-down"
        dialogClassName="guest-cart-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Sepetiniz</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
          <ListGroup variant="flush">
            {cart.length === 0 ? (
              <ListGroup.Item>Sepetinizde ürün bulunmamaktadır.</ListGroup.Item>
            ) : (
              <>
                {cart.map((item) => (
                  <ListGroup.Item key={item.lineKey || item.id} className="guest-cart-item">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="flex-grow-1">
                        <div className="guest-cart-item-name">{item.name}</div>
                        {item.modifiers?.length ? (
                          <div className="small text-muted mb-1">{formatModifierSummary(item.modifiers)}</div>
                        ) : null}
                        <div className="guest-cart-item-meta">
                          {formatPrice(item.price)} × {item.quantity}
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-3">
                        <div className="guest-cart-item-total">
                          {formatPrice(item.price * item.quantity)}
                        </div>
                        <div className="guest-cart-quantity-group">
                          <Button
                            variant="outline-danger"
                            className="guest-cart-quantity-button"
                            onClick={() => removeItem(item)}
                            aria-label={`${item.name} adedini azalt`}
                          >
                            -
                          </Button>
                          <Button
                            variant="outline-success"
                            className="guest-cart-quantity-button"
                            onClick={() => addItem(item)}
                            aria-label={`${item.name} adedini artır`}
                          >
                            +
                          </Button>
                        </div>
                      </div>
                    </div>
                    <Form.Group className="mt-3">
                      <Form.Label className="small text-muted mb-1">Ürün notu</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        maxLength={200}
                        placeholder="Örn. soğansız"
                        value={item.notes || ""}
                        onChange={(event) => setItemNote(item.lineKey || item.id, event.target.value)}
                      />
                      <div className="guest-note-counter">{(item.notes || "").length}/200</div>
                    </Form.Group>
                  </ListGroup.Item>
                ))}
              </>
            )}
          </ListGroup>
        </Modal.Body>
        <Modal.Footer>
          <div className="guest-cart-footer">
            <Form.Group className="w-100 mb-3">
              <Form.Label className="small text-muted mb-1">Sipariş notu</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                maxLength={500}
                placeholder="Örn. alerji veya servis notu"
                value={orderNote}
                onChange={(event) => setOrderNote(event.target.value)}
              />
              <div className="guest-note-counter">{orderNote.length}/500</div>
            </Form.Group>

            <div className="guest-cart-total">
              <div className="d-flex justify-content-between align-items-center">
                <span className="fw-semibold">Toplam ({totalItems} ürün)</span>
                <span className="guest-cart-item-total">{formatPrice(totalPrice)}</span>
              </div>
            </div>

            <div className="guest-cart-actions">
              <Button
                variant="success"
                size="lg"
                onClick={handleCheckout}
                disabled={cart.length === 0 || checkoutDisabled}
                className="guest-cart-checkout"
              >
                {checkoutLabel || `Sipariş Ver (${totalItems} ürün)`}
              </Button>
              <Button
                variant="outline-secondary"
                onClick={clearCart}
                disabled={cart.length === 0}
                className="guest-cart-clear"
              >
                Sepeti Boşalt
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MobileCart;
